import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const Disclaimer = () => {
    return (
        <div className="disclaimer-wrapper py-5 bg-whitesmoke">
            <Container className="bg-white shadow-sm rounded-4 p-4 p-md-5 my-5 border-top border-4 border-primary-blue">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1 className="h2 fw-bold text-dark mb-4 text-uppercase tracking-wider">Legal Disclaimer</h1>
                    <hr className="mb-4" />

                    <div className="disclaimer-content text-muted" style={{ fontSize: '0.95rem', lineHeight: '1.7' }}>
                        <p className="mb-4">
                            The information provided on this website (including <strong>CPR Cosmos, CPR Park Heights, and CPR Mangala</strong>) 
                            is for general informational purposes only. By accessing or using this website, you agree to the 
                            terms of this disclaimer without any limitation or qualification.
                        </p>

                        <section className="mb-4">
                            <h2 className="h5 fw-bold text-dark mb-2">1. Artistic Impressions</h2>
                            <p>
                                All images, walk-throughs, and renders shown are <strong>artistic impressions</strong> and are 
                                purely representational. They are intended to provide a generalized view of the proposed 
                                development and do not form part of any legal agreement or binding offer. The actual 
                                finished product, including colors, textures, and landscapes, may vary.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2 className="h5 fw-bold text-dark mb-2">2. Accuracy of Information</h2>
                            <p>
                                While <strong>CPR Constructions</strong> strives to keep the information up to date and correct, 
                                we make no representations or warranties of any kind, express or implied, about the 
                                completeness, accuracy, or reliability of the floor plans, pricing, or specifications. 
                                Unit sizes and areas are subject to minor variations during construction as permitted by RERA.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2 className="h5 fw-bold text-dark mb-2">3. Statutory Compliance (RERA)</h2>
                            <p>
                                All projects showcased are registered under the Andhra Pradesh Real Estate Regulatory Authority. 
                                Users are advised to verify the registration details and current project status on the 
                                official RERA website using the following registration numbers:
                            </p>
                            <ul className="fw-bold text-dark mt-2">
                                <li>CPR Mangala: P10110065222</li>
                                <li>CPR Cosmos: P10110064560</li>
                                <li>CPR Park Heights: P10110064321</li>
                            </ul>
                        </section>

                        <section className="mb-0">
                            <h2 className="h5 fw-bold text-dark mb-2">4. No Contractual Obligation</h2>
                            <p>
                                No information on this website constitutes an offer for sale or a solicitation to purchase. 
                                The sale of any unit is governed solely by the terms and conditions of the <strong>Agreement for Sale </strong> 
                                executed between the buyer and CPR Constructions.
                            </p>
                        </section>
                    </div>
                </motion.div>
            </Container>
        </div>
    );
};

export default Disclaimer;